import React, { HTMLProps } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import cn from 'classnames';

import './styles.scss';
import { View } from 'src/components/common';
import { Skeleton } from '@material-ui/lab';

const DepositionItemPlacehoder: React.FC<Props> = ({ className, ...props }) => {
  return (
    <View className={cn('cmp-depo-item-placeholder', 'mt-24', className)} {...props}>
      <View justify="space-between" isRow>
        <Skeleton width="320px" />
        <Skeleton variant="rect" width="84px" height="24px" />
      </View>
      <View className="mb-20">
        <Skeleton width="280px" />
      </View>
      <View isRow>
        <View className="mr-24">
          <Skeleton width="180px" />
          <Skeleton width="150px" />
          <Skeleton width="150px" />
        </View>
        <View>
          <Skeleton width="180px" />
          <Skeleton width="150px" />
          <Skeleton width="150px" />
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & HTMLProps<HTMLDivElement> & {};

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionItemPlacehoder);
